export interface SalesMetrics {
  amount: number
  cardTransactions: number
  count: number
}

export type SalesMetricKey = keyof SalesMetrics

export interface AllSalesColumn {
  key: string
  cashAdvanceName: string
  terminalName: string
  cashAdvanceId?: string
  terminalId?: string
}

export interface AllSalesMonthRow {
  month: string
  values: Record<string, SalesMetrics>
  total: SalesMetrics
}

export interface AllSalesMerchantTable {
  merchantId?: string
  merchantName: string
  cashAdvances: Array<{ name: string; columns: AllSalesColumn[] }>
  rows: AllSalesMonthRow[]
  columnTotals: Record<string, SalesMetrics>
  grandTotal: SalesMetrics
}

export interface AllSalesCellSelection {
  merchantId?: string
  cashAdvanceId?: string
  terminalId?: string
  /** Distinguishes an unassigned column from a Total-column selection. */
  filterByCashAdvance: boolean
  /** Distinguishes an unassigned terminal from a Total-column selection. */
  filterByTerminal: boolean
  month: string
  terminalName: string
}

export interface AllSalesTableLayout {
  height: string
  merchantWidth: string
  monthWidth: string
  metricWidth: string
  valueWidth: string
}

export const DEFAULT_ALL_SALES_TABLE_LAYOUT: AllSalesTableLayout = {
  height: 'min(55vh, 34rem)',
  merchantWidth: '12rem',
  monthWidth: '9rem',
  metricWidth: '12rem',
  valueWidth: '10rem',
}

export const DEFAULT_ALL_SALES_METRIC_LABELS: Record<SalesMetricKey, string> = {
  amount: 'Payments',
  cardTransactions: 'Card Transactions',
  count: 'Count',
}
